import RoyaltyStatementClass from "./RoyaltyStatement";
import PurchaseReportClass from "./PurchaseReport";
import CustomersReportClass from "./CustomersReport";
import PackagesReportClass from "./PackagesReport";
import PetsReportClass from "./PetsReport";

let MRoyaltyStatement = null;
let MPurchaseReport = null;
let MCustomersReport = null;
let MPackagesReport = null;
let MPetsReport = null;

export function RoyaltyStatementModel() {
  if (MRoyaltyStatement) {
    return MRoyaltyStatement;
  }

  MRoyaltyStatement = new RoyaltyStatementClass();
  return MRoyaltyStatement;
}

export function PurchaseReportModel() {
  if (MPurchaseReport) {
    return MPurchaseReport;
  }

  MPurchaseReport = new PurchaseReportClass();
  return MPurchaseReport;
}

export function CustomersReportModel() {
  if (MCustomersReport) {
    return MCustomersReport;
  }

  MCustomersReport = new CustomersReportClass();
  return MCustomersReport;
}

export function PetsReportModel() {
  if (MPetsReport) {
    return MPetsReport;
  }

  MPetsReport = new PetsReportClass();
  return MPetsReport;
}

export function PackagesReportModel() {
  if (MPackagesReport) {
    return MPackagesReport;
  }

  MPackagesReport = new PackagesReportClass();
  return MPackagesReport;
}
